import { render, staticRenderFns } from "./automationCopyMessageTemplatePopover.vue?vue&type=template&id=a6ff71be&scoped=true&"
import script from "./automationCopyMessageTemplatePopover.vue?vue&type=script&lang=js&"
export * from "./automationCopyMessageTemplatePopover.vue?vue&type=script&lang=js&"
import style0 from "./automationCopyMessageTemplatePopover.vue?vue&type=style&index=0&id=a6ff71be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ff71be",
  null
  
)

export default component.exports